import { render } from "./PeopleList.vue?vue&type=template&id=a68a2d38&scoped=true"
import script from "./PeopleList.vue?vue&type=script&lang=js"
export * from "./PeopleList.vue?vue&type=script&lang=js"

import "./PeopleList.vue?vue&type=style&index=0&id=a68a2d38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a68a2d38"]])

export default __exports__